export type FetchResponse<T> = {
  data: T;
  headers: Headers;
  response: Response;
  status: number;
  statusText: string;
};

export class ApiError extends Error {
  data: any;
  headers?: Headers;
  payload: any;
  status: number;
  _sentryReported: boolean;

  constructor(
    message: string,
    details: { data: any; headers?: Headers; payload: any; status: number },
  ) {
    super(message);
    this.name = 'ApiError';
    this.data = details.data;
    this.headers = details.headers;
    this.payload = details.payload;
    this.status = details.status;
    this._sentryReported = false;
  }
}
